export const getQuality = () => {
  return 0.8
}
